import { isEqual } from 'lodash'

const APP = 'dataBinding'
const TYPE = 'viewerStatusForEditor'

type ComponentPropertiesConnectedToEmptyFields = {
  propertyToField: Record<string, string>
  includesPrimaryProperty: boolean
}

export type ViewerStatus = {
  datasetSize: Record<string, number>
  componentToPropertiesConnectedToEmptyFields: Record<string, ComponentPropertiesConnectedToEmptyFields>
}

export const createSenderOfViewerStatusForEditor = ({
  global,
  postMessage,
  enabled,
}: {
  global: any
  postMessage: (message: any) => void
  enabled: boolean
}) => {
  const viewerStatus: ViewerStatus = {
    datasetSize: {},
    componentToPropertiesConnectedToEmptyFields: {},
  }
  if (global._dataBindingViewerStatusForEditorInterval) {
    global.clearInterval(global._dataBindingViewerStatusForEditorInterval)
  }
  if (enabled) {
    global._dataBindingViewerStatusForEditorInterval = global.setInterval(
      () => {
        postMessage({
          app: APP,
          type: TYPE,
          message: JSON.stringify(viewerStatus),
        })
      },
      1000,
    )
  }

  const typeToTimeoutId = new Map<string, ReturnType<typeof setTimeout>>()

  const debouncePostMessageByType = (data: object, type: string) => {
    if (typeToTimeoutId.has(type)) {
      clearTimeout(typeToTimeoutId.get(type))
    }

    typeToTimeoutId.set(type, setTimeout(() => {
      typeToTimeoutId.delete(type)
      postMessage({ app: APP, type, message: JSON.stringify(data) })
    }))
  }

  return {
    updateDatasetSize: (datasetId: string, size: number) => {
      if (enabled && viewerStatus.datasetSize[datasetId] !== size) {
        viewerStatus.datasetSize[datasetId] = size

        debouncePostMessageByType(
          viewerStatus.datasetSize,
          'datasetIdToSize',
        )
      }
    },

    updateComponentPropertiesConnectedToEmptyFields: (
      componentId: string,
      propertiesConnectedToEmptyFields: ComponentPropertiesConnectedToEmptyFields,
    ) => {
      if (
        enabled &&
        !isEqual(
          viewerStatus.componentToPropertiesConnectedToEmptyFields[componentId],
          propertiesConnectedToEmptyFields,
        )
      ) {
        viewerStatus.componentToPropertiesConnectedToEmptyFields[componentId] = propertiesConnectedToEmptyFields

        debouncePostMessageByType(
          viewerStatus.componentToPropertiesConnectedToEmptyFields,
          'componentIdToPropertiesConnectedToEmptyFields',
        )
      }
    },
  }
}
